const state = {
  showAlert: false,
  variant: "success",
  timeout: 1000,
  message: "",
};

const mutations = {
  setAlert(state, data) {
    state.showAlert = data.showAlert;
    state.message = data.message;
    state.variant = data.variant;
    state.timeout = data.timeout;
    setTimeout(() => {
      state.showAlert = false;
      state.message = "";
      state.variant = "";
      state.timeout = -1;
    }, state.timeout);
  },
  updateAlert(state, data) {
    state.showAlert = data.showAlert;
  },
  updateMessage(state, data) {
    state.message = data.message;
  },
  updateVariant(state, data) {
    state.variant = data.variant;
  },
  updateTimeout(state, data) {
    state.timeout = data.timeout;
  },
};
const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};